<template>
  <div class="mainContainer">
    <img src="../../assets/rank/bg.jpg" alt="" class="topBg" />

    <div class="topContain">
      <div class="rankListContain">
        <div
          class="rankList"
          :class="{ active: rankIndex == index }"
          v-for="(item, index) in rankList"
          :key="index"
          @click="topRankClick(index)"
        >
          <div class="rankListTitle">{{ item.top_name }}</div>
          <div class="rankLine"></div>
        </div>
      </div>
    </div>

    <div class="rankContain">
      <div class="subListContain">
        <div
          class="subList"
          :class="{ active: subIndex == index }"
          v-for="(item, index) in rankList[rankIndex].children"
          :key="index"
          @click="subRankClick(index)"
        >
          {{ item.top_name }}
        </div>
      </div>
      <div class="rankListContain">
        <div class="selectContain">
          <el-select
            v-model="periodId"
            placeholder="请选择"
            @change="getTopDetailList"
            class="selectPeriod"
            popper-class="selectPeriodPopper"
          >
            <el-option
              v-for="item in periodList"
              :key="item.id"
              :label="item.period_date + ' | ' + item.period_type"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <div class="ruleContain" @click="ruleShow = true">
            <div class="ruleTitle">榜单规则</div>
            <img src="../../assets/rank/rule.png" alt="" class="ruleIcon" />
          </div>
        </div>
        <div
          class="rankItemsContain"
          :style="{ paddingTop: style_type != 3 ? '133px' : '0' }"
        >
          <div class="topThreeContain" v-if="style_type != 3">
            <div
              class="topThreeItem topOne"
              :class="{ noCount: style_type == 3 }"
              v-if="rankItems[0]"
            >
              <img :src="rankItems[0].u_avatar" class="avatar" />
              <div class="nickName">{{ rankItems[0].u_nickname }}</div>
              <div
                class="score"
                :style="{ visibility: style_type == 1 ? 'visible' : 'hidden' }"
              >
                {{ rankItems[0].score }}
              </div>
              <el-popover
                placement="bottom"
                width="150"
                trigger="click"
                @show="codeShow(1)"
              >
                <div class="rankDetailContain">
                  <div
                    :id="'qrCode' + 1"
                    :ref="'qrCode' + 1"
                    class="qrcode"
                  ></div>
                  <div class="qrcodeText">
                    顶端新闻APP扫码<br />查看详情分享海报
                  </div>
                </div>
                <el-button slot="reference">晒榜</el-button>
              </el-popover>
            </div>
            <div class="twoThreeContain">
              <div
                class="topThreeItem"
                :class="{ noCount: style_type == 3 }"
                v-if="rankItems[1]"
              >
                <img :src="rankItems[1].u_avatar" class="avatar" />
                <div class="nickName">{{ rankItems[1].u_nickname }}</div>
                <div
                  class="score"
                  :style="{
                    visibility: style_type == 1 ? 'visible' : 'hidden',
                  }"
                >
                  {{ rankItems[1].score }}
                </div>
                <el-popover
                  placement="bottom"
                  width="150"
                  trigger="click"
                  @show="codeShow(2)"
                >
                  <div class="rankDetailContain">
                    <div
                      :id="'qrCode' + 2"
                      :ref="'qrCode' + 2"
                      class="qrcode"
                    ></div>
                    <div class="qrcodeText">
                      顶端新闻APP扫码<br />查看详情分享海报
                    </div>
                  </div>
                  <el-button slot="reference">晒榜</el-button>
                </el-popover>
              </div>
              <div
                class="topThreeItem"
                :class="{ noCount: style_type == 3 }"
                v-if="rankItems[2]"
              >
                <img :src="rankItems[2].u_avatar" class="avatar" />
                <div class="nickName">{{ rankItems[2].u_nickname }}</div>
                <div
                  class="score"
                  :style="{
                    visibility: style_type == 1 ? 'visible' : 'hidden',
                  }"
                >
                  {{ rankItems[2].score }}
                </div>
                <el-popover
                  placement="bottom"
                  width="150"
                  trigger="click"
                  @show="codeShow(3)"
                >
                  <div class="rankDetailContain">
                    <div
                      :id="'qrCode' + 3"
                      :ref="'qrCode' + 3"
                      class="qrcode"
                    ></div>
                    <div class="qrcodeText">
                      顶端新闻APP扫码<br />查看详情分享海报
                    </div>
                  </div>
                  <el-button slot="reference">晒榜</el-button>
                </el-popover>
              </div>
            </div>
          </div>
          <el-table :data="style_type == 3 ? rankItems : rankItems.slice(3)">
            <el-table-column width="80" label="排名" v-if="style_type != 3">
              <template slot-scope="{ row }">
                <div class="count">{{ row.no }}</div>
              </template>
            </el-table-column>
            <el-table-column label="顶端号昵称">
              <template slot-scope="{ row }">
                <div class="nameContain">
                  <img :src="row.u_avatar" alt="" class="avatar" />
                  <div class="nickName">{{ row.u_nickname }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              label="总分"
              align="center"
              v-if="style_type == 1"
            >
              <template slot-scope="{ row }">
                {{ row.score }}
              </template>
            </el-table-column>
            <el-table-column width="130" label="晒榜" align="center">
              <template slot-scope="{ row }">
                <div class="shareBtnContain">
                  <el-popover
                    placement="bottom"
                    width="150"
                    trigger="click"
                    @show="codeShow(parseInt(row.no))"
                  >
                    <div class="rankDetailContain">
                      <div
                        :id="'qrCode' + parseInt(row.no)"
                        :ref="'qrCode' + parseInt(row.no)"
                        class="qrcode"
                      ></div>
                      <div class="qrcodeText">
                        顶端新闻APP扫码<br />查看详情分享海报
                      </div>
                    </div>
                    <el-button slot="reference">晒榜</el-button>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="moreRankItem" v-if="rankItems.length > 3">
            {{ isAll ? "没有更多了" : "加载更多..." }}
          </div>
        </div>
      </div>
    </div>

    <div class="ruleTextContain" v-if="ruleShow">
      <img
        src="../../assets/rank/close.png"
        alt=""
        class="closeIcon"
        @click="ruleShow = false"
      />
      <div class="ruleTitle">榜单规则</div>
      <div class="rules" v-html="rules"></div>
    </div>
  </div>
</template>

<script>
import { BI_HOST, SWNEWS_HOST } from "../../constants/apiHosts";
import dbRequest from "../../plugin/request-bd";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      rankIndex: 0,
      rankList: [
        {
          children: [],
        },
      ],
      subIndex: 0,
      periodList: [],
      periodId: "",
      page: 1,
      size: 10,
      isAll: true,
      rankItems: [],
      ruleShow: false,
      rules: "",
      style_type: 1,
    };
  },
  created() {
    this.getTopTree();

    this.trackFn();
  },
  mounted() {},
  methods: {
    trackFn() {
      dbRequest({
        url: `${BI_HOST}/bd`,
        method: "POST",
        params: {
          b_type: "优质顶端号榜单",
        },
      }).then((res) => {
        if (res.data.code == 200) {
        } else {
          //this.$message.error(res.data.msg);
        }
      });
    },
    getTopTree() {
      this.$axios.get(`${SWNEWS_HOST}/api/top/getTopTree`).then((res) => {
        if (res.data.code == 0) {
          this.rankList = res.data.data;

          this.getTopPeriodList(
            this.rankList[this.rankIndex].children[this.subIndex].id
          );
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    topRankClick(index) {
      this.subIndex = 0;
      this.rankIndex = index;

      this.getTopPeriodList(
        this.rankList[this.rankIndex].children[this.subIndex].id
      );
    },
    subRankClick(index) {
      this.subIndex = index;

      this.getTopPeriodList(
        this.rankList[this.rankIndex].children[this.subIndex].id
      );
    },
    getTopPeriodList(top_id) {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/top/getTopPeriodList?top_id=${top_id}&top_pid=${
            this.rankList[this.rankIndex].id
          }`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.periodList = res.data.data.top_period;

            if (this.periodList.length) {
              this.periodId = this.periodList[0].id;
              this.getTopDetailList();
            } else {
              this.periodId = "";
              this.rankItems = [];
              this.ruleShow = false;
              this.rules = "";
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getTopDetailList() {
      this.ruleShow = false;
      this.periodList.forEach((item) => {
        if (item.id == this.periodId) {
          this.rules = item.rule;
          this.style_type = item.style_type;
        }
      });

      this.$axios
        .get(
          `${SWNEWS_HOST}/api/top/getTopDetailList?top_period_id=${this.periodId}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((item, index) => {
              item.no = index + 1 < 10 ? "0" + (index + 1) : index + 1;
            });
            this.rankItems = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    codeShow(index) {
      this.$nextTick(() => {
        let qrCodeElem = document.getElementById("qrCode" + index);
        qrCodeElem.innerHTML = "";
        let qrCode = new QRCode(this.$refs["qrCode" + index], {
          text:
            (window.location.href.indexOf("dingxinwen.com") > 0 ||
            window.location.href.indexOf("topnews.cn") > 0
              ? "https://static.dingxinwen.com"
              : "https://static.dingnews.net") +
            `/ddTop/index.html#/rank?top_id=${
              this.rankList[this.rankIndex].children[this.subIndex].id
            }&top_pid=${this.rankList[this.rankIndex].id}`,
          with: 256,
          height: 256,
        });
        qrCode._el.title = "";
      });
    },
  },
};
</script>

<style lang="scss">
.selectPeriodPopper {
  .el-select-dropdown__item {
    color: #333333;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
  }

  .selected {
    background: #fffcf4;
    color: #c87c0e;
  }

  .hover {
    background: #fffcf4;
  }
}

.rankDetailContain {
  display: flex;
  flex-direction: column;
  align-items: center;

  .qrcode {
    width: 100px;
    height: 100px;
  }

  .qrcodeText {
    color: #333333;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    margin-top: 8px;
  }
}
</style>

<style lang="scss" scoped>
.mainContainer {
  background: #fff;
  position: relative;

  .topBg {
    width: 1920px;
    height: 534px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -960px;
    max-width: 1920px !important;
  }

  .topContain {
    position: relative;
    padding-top: 466px;
    display: flex;
    justify-content: center;

    .rankListContain {
      width: 1280px;
      display: flex;
      border-radius: 8px;
      border: 1px solid #fff;
      background: #ffffffcc;
      padding: 14px 8px 0 8px;

      .rankList {
        color: #666666;
        font-family: "PingFang SC";
        font-size: 21px;
        font-weight: 400;
        line-height: 34px;
        padding: 0 16px;
        cursor: pointer;
      }

      .rankLine {
        border-radius: 2px;
        width: 48px;
        height: 4px;
        margin: 10px auto 0 auto;
      }

      .active {
        color: #333333;
        font-size: 24px;
        font-weight: 500;

        .rankLine {
          background: #f32432;
        }
      }
    }
  }

  .rankContain {
    width: 1280px;
    margin: 0 auto;
    padding-bottom: 80px;
    position: relative;

    .subListContain {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      padding-left: 24px;

      .subList {
        border-radius: 8px;
        background: #f5f5f5;
        padding: 0 24px;
        color: #666666;
        font-family: "PingFang SC";
        font-size: 21px;
        font-weight: 400;
        line-height: 42px;
        margin-right: 16px;
        cursor: pointer;
        flex-shrink: 0;
        margin-bottom: 16px;
      }

      .active {
        background: #fff4db;
        color: #c87c0e;
      }
    }

    .rankListContain {
      border-radius: 8px;
      border: 1px solid #ffe2b3;
      margin-top: 8px;
      padding: 89px 182px 34px 182px;
      position: relative;

      .selectContain {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        top: 25px;
        right: 32px;

        /deep/.selectPeriod {
          width: 200px;
          border-radius: 4px;
          margin-right: 60px;

          .el-input__inner {
            background: #fff4db;
            border: 0;
            color: #c87c0e;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 400;
          }

          .el-select__caret {
            background: #fff4db;
            color: #c87c0e;
          }

          .el-input--suffix {
            margin: 0;
          }
        }

        .ruleContain {
          display: flex;
          align-items: center;
          cursor: pointer;

          .ruleTitle {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 400;
            margin-right: 12px;
          }

          .ruleIcon {
            height: 24px;
          }
        }
      }

      .rankItemsContain {
        position: relative;
        padding-top: 133px;

        .topThreeItem {
          width: 282px;
          height: 339px;
          position: relative;
          padding-top: 82px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .avatar {
            width: 124px;
            height: 124px;
            border-radius: 50%;
            object-fit: cover;
            position: absolute;
            left: 50%;
            top: -56px;
            margin-left: -62px;
          }

          .nickName {
            color: #333333;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 24px;
            font-weight: 500;
            line-height: 50.63px;
            letter-spacing: 0.24p;
          }

          .score {
            color: #666666;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 400;
            line-height: 25px;
            margin-top: 5px;
          }

          .el-button {
            width: 110px;
            height: 44px;
            border-radius: 29.53px;
            border: 1px solid #fff4db;
            padding: 0 !important;
            margin-top: 45px;

            &:hover,
            &:focus {
              background-color: #fff;
            }

            /deep/span {
              color: #c87c0e;
              text-align: center;
              font-feature-settings: "liga" off, "clig" off;
              font-family: "PingFang SC";
              font-size: 21px;
              font-weight: 400;
            }
          }
        }

        .topOne {
          background: url("../../assets/rank/no1.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          left: 50%;
          top: 63px;
          margin-left: -141px;

          .avatar {
            border: 4px solid #ffc55b;
          }
        }

        .topOne.noCount {
          background: url("../../assets/rank/no1no.png") no-repeat;
          background-size: 100% 100%;
        }

        .topThreeContain {
          height: 305px;
        }

        .twoThreeContain {
          display: flex;
          justify-content: space-between;

          .topThreeItem:nth-child(1) {
            background: url("../../assets/rank/no2.png") no-repeat;
            background-size: 100% 100%;

            .avatar {
              border: 4px solid #d8d8d8;
            }
          }

          .topThreeItem:nth-child(1).noCount {
            background: url("../../assets/rank/no2no.png") no-repeat;
            background-size: 100% 100%;
          }

          .topThreeItem:nth-child(2) {
            background: url("../../assets/rank/no3.png") no-repeat;
            background-size: 100% 100%;

            .avatar {
              border: 4px solid #ffa27d;
            }
          }

          .topThreeItem:nth-child(2).noCount {
            background: url("../../assets/rank/no3no.png") no-repeat;
            background-size: 100% 100%;
          }
        }

        .el-table {
          /deep/th {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 400;
            line-height: 49px;

            &:nth-child(2) {
              padding-left: 57px;
            }

            &:nth-last-child(2) {
              padding-left: 0;
            }
          }

          /deep/.el-table__body tr:hover > td {
            background-color: #fff !important;
          }

          /deep/td {
            padding: 17px 0;

            .cell {
              display: flex;
              align-items: center;
            }

            .count {
              color: #e9cb9f;
              font-family: "Source Han Sans CN";
              font-size: 27px;
              font-weight: 500;
            }

            .nameContain {
              display: flex;
              align-items: center;

              .avatar {
                width: 80px;
                height: 80px;
                border-radius: 50%;
                object-fit: cover;
                margin-right: 19px;
                border: 3px solid #ffe2b3;
              }

              .nickName {
                color: #333333;
                font-family: "Source Han Sans CN";
                font-size: 24px;
                font-weight: 500;
              }
            }

            &:nth-child(3) {
              .cell {
                color: #333333;
                font-family: "PingFang SC";
                font-size: 24px;
                font-weight: 400;
                text-align: center;
                justify-content: center;
              }
            }

            &:nth-child(4) {
              .cell {
                justify-content: center;

                .el-button span {
                  color: #666666;
                  text-align: center;
                  font-feature-settings: "liga" off, "clig" off;
                  font-family: "PingFang SC";
                  font-size: 24px !important;
                  font-weight: 400;
                }

                .el-button {
                  width: 110px;
                  height: 44px;
                  border-radius: 29.53px;
                  background-color: #f6f7f9;
                  padding: 0 !important;
                  border: 0;

                  &:hover,
                  &:focus {
                    background-color: #f6f7f9;
                    border: 0;
                    color: #666666;
                  }
                }
              }
            }

            .shareBtnContain {
              width: 100%;
              display: flex;
              justify-content: center;
              background: #f6f7f9;
              border-radius: 29.53px;
              overflow: hidden;

              .el-button {
                border: 0;
                background: #f6f7f9;

                span {
                  font-family: "PingFang SC";
                  font-size: 24px;
                  font-weight: 400;
                  color: #666666;
                }
              }
            }
          }
        }

        .moreRankItem {
          color: #999999;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 18px;
          font-weight: 400;
          line-height: 25px;
          cursor: pointer;
          padding-top: 28px;
        }
      }
    }
  }

  .ruleTextContain {
    border-radius: 16px;
    background: #f6f7f9;
    width: 940px;
    height: 90vh;
    padding: 64px 32px 32px 32px;
    position: fixed;
    top: 5vh;
    left: 50%;
    margin-left: -470px;
    display: flex;
    flex-direction: column;

    .closeIcon {
      height: 24px;
      position: absolute;
      right: 24px;
      top: 24px;
      cursor: pointer;
    }

    .ruleTitle {
      color: #333333;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 28px;
      font-weight: 500;
      line-height: 39px;
    }

    .rules {
      flex: 1;
      min-height: 0;
      border-radius: 16px;
      background: #fff;
      padding: 32px 27px;
      color: #333333;
      font-family: "PingFang SC";
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      margin-top: 48px;
      white-space: pre-wrap;
      overflow-y: scroll;
    }
  }
}
</style>
